import type { SearchSchemaInput } from '@tanstack/react-router';
import { parseEnum } from '@/shared/lib/listSearch';
import { TransferWindowDtoStatus } from '@/api/generated/model';

/** Ordered as the timeline reads: what is open, what is coming, what has gone. */
export const WINDOW_STATUSES = [
  TransferWindowDtoStatus.open,
  TransferWindowDtoStatus.openSoon,
  TransferWindowDtoStatus.closed,
] as const;

export interface TransferWindowsSearch {
  /** Undefined means all statuses. */
  status?: TransferWindowDtoStatus | undefined;
}

/**
 * The status filter lives in the URL, like every other filter in the app, so a
 * view of "what is open right now" is shareable and survives a refresh.
 *
 * Narrowed against the generated enum: a hand-edited `?status=opensoon` becomes
 * "all" rather than filtering every row out and looking like an empty account.
 */
export function validateTransferWindowsSearch(
  search: Partial<Record<keyof TransferWindowsSearch, unknown>> & SearchSchemaInput,
): TransferWindowsSearch {
  return { status: parseEnum(search.status, WINDOW_STATUSES) };
}
